import { i18n } from "~/localization/i18n";

const UNITS = [
    { unit: "day", seconds: 60 * 60 * 24 },
    { unit: "hour", seconds: 60 * 60 },
    { unit: "minute", seconds: 60 },
];

export function formatDurationToNow(date, now = new Date(), languageCode = i18n.languages?.[0]) {
    if (!date) return null;

    const targetDate = typeof date === "string" ? new Date(date) : date;
    const nowDate = typeof now === "string" ? new Date(now) : (now ?? new Date());
    const diffSeconds = Math.max(0, Math.round((targetDate.valueOf() - nowDate.valueOf()) / 1000));

    const { unit, value } = pickUnitAndValue(diffSeconds);

    return new Intl.NumberFormat(languageCode, {
        style: "unit",
        unit,
        unitDisplay: "long",
    }).format(value);
}

function pickUnitAndValue(diffSeconds) {
    for (const { unit, seconds } of UNITS) {
        if (diffSeconds >= seconds) {
            return { unit, value: Math.round(diffSeconds / seconds) };
        }
    }
    return { unit: "minute", value: 0 };
}
